import { client } from 'src/utils/api';

import { UploadServerScreeningContentRequest } from './types';

export const uploadServerScreeningContents = (body: UploadServerScreeningContentRequest) =>
  client.post('/match-helper/v1/screening/contents', body);
